import type { LineDetails } from "../types";
import { getNetworkColor } from "./networkColor";

export function normalizeLineKey(value: unknown) {
  return String(value ?? "").trim();
}

export function getLineAliasKeys(
  line: LineDetails | null | undefined
): string[] {
  if (!line) return [];

  const aliases = [
    line.id,
    (line as any).LineNrReal,
    (line as any).lineNrReal,
    (line as any).LineName,
    (line as any).lineName,
    (line as any).PublicLineNumber,
    (line as any).publicLineNumber,
    (line as any).PresentationLineNr,
    (line as any).presentationLineNr,
    (line as any).GroupLineNrReal,
    (line as any).groupLineNrReal,
  ];

  return Array.from(new Set(aliases.map(normalizeLineKey).filter(Boolean)));
}

export function lineMatchesId(
  line: LineDetails | null | undefined,
  id: unknown
) {
  const key = normalizeLineKey(id);

  if (!line || !key) return false;

  return getLineAliasKeys(line).includes(key);
}

export function getLineMapColor(line: LineDetails) {
  const key = normalizeLineKey(line.id) || getLineAliasKeys(line)[0] || "";

  return getNetworkColor(key);
}
